const labelReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default labelReducer;